import { render } from "./Create.vue?vue&type=template&id=a7f49db0"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render

export default script